import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Sidebar } from '../components/navigation/sidebar'
import { useState } from 'react'
import { IntroOverlay } from '../components/intro/introOverlay'
import { EasterEggs } from '../components/easterEggs'

const RootComponent = () => {
    const [showIntro, setShowIntro] = useState(() => {
        return localStorage.getItem('introSeen') !== 'true'
    })

    return (
        <>
            {
                showIntro ? (<IntroOverlay onFinish={() => setShowIntro(false)} />) : (
                    <div style={{ display: 'flex', minHeight: '100vh' }} >
                        <Sidebar />
                        <main style={{ flex: 1, padding: '1rem' }}>
                            <Outlet />
                        </main>
                        <EasterEggs />
                        <TanStackRouterDevtools />
                    </div >
                )
            }
        </>
    )
}

export const Route = createRootRoute({
    component: RootComponent
})